import { AxiosResponse } from "axios";
import api from "./client";

// My Data for a tenant
export const getMyData = (tenant_id: string): Promise<AxiosResponse> =>
  api.post("/user/my-data", { tenant_id });

// Consent data for a tenant
export const getConsentDataByTenant = (tenant_id: string): Promise<AxiosResponse> =>
  api.post("/user/consent-data", { tenant_id });
